// src/components/Header.js
import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { FaShoppingCart } from "react-icons/fa";
import { FaBars, FaTimes } from "react-icons/fa";
import Cart from "./Cart";
import "../styles/Header.css"

function Header() {
  const location = useLocation();
  const [isCartFullScreen, setIsCartFullScreen] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  const [cartItems, setCartItems] = useState(() => {
    const stored = localStorage.getItem("cart");
    return stored ? JSON.parse(stored) : [];
  });

  useEffect(() => {
    const handleStorage = () => {
      const stored = localStorage.getItem("cart");
      setCartItems(stored ? JSON.parse(stored) : []);
    };
    window.addEventListener("storage", handleStorage);
    return () => window.removeEventListener("storage", handleStorage);
  }, []);

  const totalItems = cartItems.reduce((acc, item) => acc + (item.quantity || 1), 0);
  const totalPrice = cartItems.reduce((acc, item) => acc + ((item.price * (item.quantity || 1)) / 100), 0);

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  const closeMenu = () => {
    setMenuOpen(false);
  };

  return (
    <>
      <header className="header">
        {!isCartFullScreen && (
          <>
            <div className="logo-wrapper">
              <Link to="/" onClick={closeMenu}>
                <img src="/images/doinaRoLogo.jpg" alt="DoinaRo28 Logo" className="logo" />
              </Link>
            </div>

            <button
              className="menu-toggle"
              onClick={toggleMenu}
              aria-label={menuOpen ? "Cerrar menú" : "Abrir menú"}
              style={{ background: "none", border: "none", cursor: "pointer", color: "white", fontSize: "1.5rem" }}
            >
              {menuOpen ? <FaTimes /> : <FaBars />}
            </button>

            <nav className={`nav${menuOpen ? " open" : ""}`}>
              <Link to="/" className={location.pathname === "/" ? "active" : ""} onClick={closeMenu}>Inicio</Link>
              <Link to="/about" className={location.pathname === "/about" ? "active" : ""} onClick={closeMenu}>Sobre mí</Link>
              <Link to="/blog" className={location.pathname === "/blog" ? "active" : ""} onClick={closeMenu}>Blog</Link>
              <Link to="/galery" className={location.pathname === "/galery" ? "active" : ""} onClick={closeMenu}>Galería</Link>
              <Link to="/books" className={location.pathname === "/books" ? "active" : ""} onClick={closeMenu}>Tienda</Link>
              <Link to="/contact" className={location.pathname === "/contact" ? "active" : ""} onClick={closeMenu}>Contacto</Link>
            </nav>

            <button
              className="cart-button"
              onClick={() => setIsCartFullScreen(true)}
              style={{ background: "none", border: "none", cursor: "pointer" }}
            >
              <FaShoppingCart size={20} color="white" />
              <span className="cart-info">
                <span style={{ color: "#fff" }}>{totalItems}</span> | <span style={{ color: "#fff" }}>€{totalPrice.toFixed(2)}</span>
              </span>
            </button>
          </>
        )}
      </header>

      {isCartFullScreen && (
        <Cart
          className="nav"
          isOpen={true}
          onClose={() => setIsCartFullScreen(false)}
          centered={true}
        />
      )}
    </>
  );
}

export default Header;